const isTagAttachedToCompany = ({company, tag}) =>
  !![...(tag?.companies || [])].find(
    ({company_id}) => company_id.replace('company_', '') === company.CompanyId
  );

export default isTagAttachedToCompany;
